module.exports = __webpack_public_path__ + "static/media/google.11b1fe14.png";